import type { TaxonomyOption } from "cmw-client";
import { activeFilters, type DirectoryFilters, type FilterKey } from "./filters";
import { GENDER_OPTIONS, PRACTITIONER_TYPE_OPTIONS, SESSION_FORMAT_LABELS, toLabelMap } from "./options";

export type FilterChip = { key: FilterKey; value: string; label: string };

const staticLabels = (): Partial<Record<FilterKey, Record<string, string>>> => ({
  gender: Object.fromEntries(GENDER_OPTIONS.map((option) => [option.value, option.label])),
  practitionerType: Object.fromEntries(PRACTITIONER_TYPE_OPTIONS.map((option) => [option.value, option.label])),
  sessionFormat: SESSION_FORMAT_LABELS,
});

export const toFilterChips = (
  filters: DirectoryFilters,
  taxonomy?: Record<string, TaxonomyOption[]>,
): FilterChip[] => {
  const fixed = staticLabels();

  return Object.entries(activeFilters(filters)).flatMap(([key, values]) => {
    const labels = fixed[key as FilterKey] ?? toLabelMap(taxonomy?.[key]);
    return values.map((value) => ({ key: key as FilterKey, value, label: labels[value] ?? value }));
  });
};

export const withoutChip = (filters: DirectoryFilters, chip: FilterChip): DirectoryFilters =>
  activeFilters({ ...filters, [chip.key]: (filters[chip.key] ?? []).filter((value) => value !== chip.value) });
